import React, { useState } from "react";
import { gtmCustomButtonEvent } from "../../helpers/GoogleTagManager/dataLayerEvents";
import { CustomButtonEvent } from "../../helpers/GoogleTagManager/types/CustomButtonEvent";
import { DataLayerConfig } from "../../helpers/GoogleTagManager/types/DataLayerConfig";
import styles from "./PrimaryButton.module.scss";

interface PrimaryButtonProps {
  text: string;
  link: string;
  size: "small" | "medium" | "large";
  textColor?: "black" | "white";
  buttonColor?: string;
  borderColor?: string;
  hoverColor?: string;
  dataLayerConfig: DataLayerConfig;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  text,
  link,
  size,
  textColor = "#fff",
  buttonColor = "#499fd4",
  borderColor = "#dddddd",
  hoverColor = "#188abf",
  dataLayerConfig,
}) => {
  const [hover, setHover] = useState<boolean>(false);

  function getFontSize() {
    switch (size) {
      case "small":
        return ".8rem";
      case "medium":
        return "1rem";
      case "large":
        return "1.2rem";
      default:
        return "1rem";
    }
  }

  return (
    <a
      target="_blank"
      rel="noreferrer"
      className={styles.buttonContainer}
      href={link}
      style={{
        color: textColor,
        backgroundColor: hover ? hoverColor : buttonColor,
      }}
      onPointerOver={() => {
        setHover(true);
      }}
      onPointerOut={() => {
        setHover(false);
      }}
      onClick={() => {
        gtmCustomButtonEvent(
          CustomButtonEvent.PRIMARY_BUTTON_CLICK,
          text,
          dataLayerConfig
        );
      }}
    >
      <div
        className={styles.buttonContent}
        style={{ fontSize: getFontSize(), borderColor: borderColor }}
      >
        {text}
      </div>
    </a>
  );
};

export default PrimaryButton;
